"use client";
import { IBlocks } from "@/types";
import BlockToggle from "../toggle";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Card } from "@/components/ui/card";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function GithubUserOptions({
    block,
    blockUpdate,
    update,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [url, setUrl] = React.useState(block.url);
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting
                noBorder
                title="GitHub username"
                description="No URL, just your GitHub username and we'll do the rest!"
            >
                <Input
                    variant="card"
                    className="w-full"
                    type="text"
                    placeholder="tommerty"
                    value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                        blockUpdate({
                            ...block,
                            url: e.target.value,
                        });
                    }}
                    onBlur={(e) => {
                        if (oldBlock.url != e.target.value) {
                            update({
                                ...block,
                                url: e.target.value,
                            });
                            setOldBlock({
                                ...oldBlock,
                                url: e.target.value,
                            });
                        }
                    }}
                />
            </CardSetting>
            <CardSetting title="Options" noBorder>
                <div className="flex w-full flex-col gap-3">
                    <div className="flex items-center justify-between gap-4">
                        <Label>Total Stars Earned</Label>
                        <Switch
                            checked={block.options.stars}
                            onCheckedChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        stars: value,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <Label>Contributed To</Label>
                        <Switch
                            checked={block.options.contribs}
                            onCheckedChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        contribs: value,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <Label>Total PRs</Label>
                        <Switch
                            checked={block.options.prs}
                            onCheckedChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        prs: value,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <Label>Total Issues</Label>
                        <Switch
                            checked={block.options.issues}
                            onCheckedChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        issues: value,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <Label>Show Rank</Label>
                        <Switch
                            checked={block.options.rank}
                            onCheckedChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        rank: value,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
            </CardSetting>
        </div>
    );
}

export function BlockOptions({ block, blockUpdate, update }: Props) {
    return (
        <BlockToggle block={block} blockUpdate={blockUpdate} update={update} />
    );
}
